import WEPCGCustomers from "./page/components/WEPCGCustomers";
import WEDCGCustomers from "./page/components/WEDCGCustomers";
import Internal from "./page/components/Approval";
import Status from "./page/components/Status";
import Materials from "./page/components/Materials";
import FAQ from "./page/components/FAQ";
import Support from "./page/components/Support";
import LoginPage from "./page/login/login";
import DisputeHome from "./page/components/DisputeHome";
import EMPCGCustomers from "./page/components/EMPCGCustomers";
import EMDCGCustomers from "./page/components/EMDCGCustomers";
import SingleCreateFinancialClaim from "./page/components/financialclaim/SingleCreateFinancialClaim";
import FinancialClaimMassUpload from "./page/components/financialclaim/FinancialClaimMassUpload";
import SingleFinancialClaimEdit from "./page/components/financialclaim/SingleFinancialClaimEdit";
import SingleFinancialClaimSearch from "./page/components/financialclaim/SingleFinancialClaimSearch";
import DisputeApproval from "./page/components/disputeApproval/disputeApproval";
import DisputeReport from "./page/components/statusReport/disputeReport";
import CBSOCreateFinancialClaim from "./page/components/financialclaim/CBSOCreateFinancialClaim";
import CBSOClaimApproval from "./page/components/disputeApproval/CBSOClaimApproval";
import CBSOMassUpload from "./page/components/financialclaim/CBSOMassUpload";
import CBSOFinancialClaimSearch from "./page/components/financialclaim/CBSOFinancialClaimSearch";
import FinClaimApproval from "./page/components/disputeApproval/finClaimApproval";
import SuccessContent from "./page/components/success";
import DisputeSummary from "./page/components/DisputeSummary";
import ClaimReport from "./page/components/statusReport/financialClaimReport";
import CBSOClaimReport from "./page/components/statusReport/CBSOClaimReport";
import USFLogin from './page/login/usfLogin'
import LenovoIdLogin from "./page/login/lenovoIdLogin";
import SAPLogin from "./page/login/sapLogin";
import LHP from "./page/components/LHP";

export const routes = [
    {
        path:"/login",
        exact:true,
        component: <LoginPage />
    },
    {
        path:"/usfLogin",
        exact:true,
        component: <USFLogin />
    },
    {
        path:"/sapLogin",
        exact:true,
        component: <SAPLogin />
    },
    {
        path:"/callback",
        exact:true,
        component: <LenovoIdLogin />
    },
    {
        path:"/disputeHome",
        exact:true,
        component: <DisputeHome />
    },
    {
        path:"/wepcgcustomers",
        exact:true,
        component: <WEPCGCustomers />
    },
    {
        path:"/empcgcustomers",
        exact:true,
        component: <EMPCGCustomers />
    },
    {
        path:"/wedcgcustomers",
        exact:true,
        component: <WEDCGCustomers />
    },
    {
        path:"/emdcgcustomers",
        exact:true,
        component: <EMDCGCustomers />
    },
    {
        path:"/singleCreateFinancialClaim",
        exact:true,
        component: <SingleCreateFinancialClaim />
    },
    {
        path:"/financialClaimMassUpload",
        exact:true,
        component: <FinancialClaimMassUpload />
    },
    {
        path:"/singleFinancialClaimEdit",
        exact:true,
        component: <SingleFinancialClaimEdit />
    },
    {
        path:"/singleFinancialClaimSearch",
        exact:true,
        component: <SingleFinancialClaimSearch />
    },
    {
        path:"/CBSOCreateFinancialClaim",
        exact:true,
        component: <CBSOCreateFinancialClaim />
    },
    {
        path:"/CBSOMassUpload",
        exact:true,
        component: <CBSOMassUpload />
    },
    {
        path:"/CBSOFinancialClaimSearch",
        exact:true,
        component: <CBSOFinancialClaimSearch />
    },
    {
        path:"/disputeApproval",
        exact:true,
        component: <DisputeApproval />
    },
    {
        path:"/finClaimApproval",
        exact:true,
        component: <FinClaimApproval />
    },
    {
        path:"/disputeReport",
        exact:true,
        component: <DisputeReport />
    },
    {
        path:"/approval",
        exact:true,
        component: <Internal />
    },
    {
        path:"/status",
        exact:true,
        component: <Status />
    },
    {
        path:"/Materials",
        exact:true,
        component: <Materials />
    },
    {
        path:"/faq",
        exact:true,
        component: <FAQ />
    },
    {
        path:"/support",
        exact:true,
        component: <Support />
    },
    {
        path:"/successful",
        exact:true,
        component: <SuccessContent />
    },
    {
        path:"/disputeSummary",
        exact:true,
        component: <DisputeSummary />
    },
    {
        path:"/CBSOClaimApproval",
        exact:true,
        component: <CBSOClaimApproval />
    },
    {
        path:"/claimReport",
        exact:true,
        component: <ClaimReport />
    },
    {
        path:"/CBSOClaimReport",
        exact:true,
        component: <CBSOClaimReport />
    },
    {
        path:"/lhp",
        exact:true,
        component: <LHP />
    },
]
